import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { TENANTS, detectTenantFromPath, type TenantConfig } from "@/platform/tenants/registry";

/**
 * Devolve o tenant ativo baseado na rota atual.
 * Retorna null em rotas puramente platform-level (/, /precos, /sobre, etc).
 */
export function useTenant(): TenantConfig | null {
  const { pathname } = useLocation();
  return useMemo(() => {
    const slug = detectTenantFromPath(pathname);
    return slug ? TENANTS[slug] : null;
  }, [pathname]);
}
